<template>
  <div>
      <van-cell title="修改密码" is-link @ @click="goTo('/updatePassword')" />
  </div>
</template>

<script>
   export default {
      methods: {
         goTo(path) {
            this.$router.push(path)
         }
      },
   }
</script>

<style>

</style>